import { redirect, useParams } from "react-router";

import type { PATHS } from "@/routes/paths";

import type { ParamParseKey } from "react-router";

export const useGetCampaignCreateNewCampaignPageParams = () => {
	const { hotelID } = useParams<ParamParseKey<typeof PATHS.HOTEL.MARKETING.CAMPAIGN.NEW>>();

	if (!hotelID) {
		redirect("/");
	}

	return { hotelID: hotelID! };
};
